import { TestStatusType } from '@Components/TestCard/TestCard.types';
import { ReduxMetaData } from '@Types/reduxMetaData.types';
import {
	ServerType,
	DateType,
	QuoteType,
	ServerTypeOledb,
} from './CreateNewSystemConnectionRequest';

export type DatabaseDateFormat = 'YYYY-MM-DD' | 'DD-MMM-YYYY'; // deprecated
export type QuoteFormat = 'DOUBLE_QUOTE' | 'BACK_TICK'; // non-visible options: 'NO_QUOTE' | 'SINGLE_QUOTE'
export type TimestampConversionFormat =
	| 'IMPLICIT'
	| 'TIMESTAMP_prefix'
	| 'TS_function';
export type TagFieldFormat = 'STRING' | 'NUMBER';

export interface SystemConnection {
	connectionId?: string;
	connectionName: string;
	serverType: string;
	connectionType: string;
	timeout: number;
	serverAddress: string;
	SystemConnectionId: string;
	connectionString: string;
	port: number;
	database: string;
	databaseTimezone: string;
	sampleDurationSeconds: number;
	queryLagMinutes: number;
	queryGroupSize: number;
	caseSensitiveSensorId: boolean;
	simulationSubtractionDays: number;
	dateTimeFormat: DatabaseDateFormat;
	quoteFormat: QuoteFormat;
	resourcePath: string;
	opcuaUrl: string;
	timestampConversion: TimestampConversionFormat;
	tagFormat: TagFieldFormat;
	securityMode: string;
	securityPolicy: string;
	endpointMustExist: string;
	sessionName: string;
	queryPrefix?: string;
	username?: string;
	password?: string;
}

export interface SystemConnectionsStoreState extends ReduxMetaData {
	list: SystemConnection[];
	testSystemConnectionStatus: TestStatusType;
	isCurrentlyDeleting: boolean;
	isUpdating: boolean;
}

export interface SystemConnections {
	systemConnections: SystemConnection[];
}

export interface DriverOption {
	label: string;
	value: DatabaseDateFormat;
}

export interface QuoteOption {
	label: string;
	value: QuoteFormat;
}

export interface DbDateTimeConversionOption {
	label: string;
	value: TimestampConversionFormat;
}
export interface DbTagFormatOption {
	label: string;
	value: TagFieldFormat;
}
export type DateFormatOption = Record<DateType, DriverOption>;
export type QuoteFormatOption = Record<QuoteFormat, QuoteOption>;
export type TimestampConversionOption = Record<
	TimestampConversionFormat,
	DbDateTimeConversionOption
>;
export type TagFieldFormatOption = Record<TagFieldFormat, DbTagFormatOption>;

export const DateTypeOptions: DateType[] = ['ANSI', 'ORACLE'];
export const QuoteOptions: QuoteType[] = ['DOUBLE_QUOTE', 'BACK_TICK'];
export const ServerTypeOptions: ServerType[] = [
	'MSSQL',
	'MYSQL',
	'ORACLE',
	'PI',
	'PIProvider',
	'ClearSCADA',
];
export const ServerTypeOptionsOledb: ServerTypeOledb[] = [
	'SQLOLEDB',
	'ihOLEDB.iHistorian.1',
];
export const ConnectionTypeOptions: string[] = ['ODBC', 'OPC-UA', 'OLEDB'];
export const DateFormatOptions: DateFormatOption = {
	ANSI: { label: 'YYYY-MM-DD [ANSI]', value: 'YYYY-MM-DD' },
	ORACLE: { label: 'DD-MMM-YYYY [ORACLE]', value: 'DD-MMM-YYYY' },
};
export const QuoteFormatOptions: QuoteFormatOption = {
	DOUBLE_QUOTE: { label: 'DOUBLE_QUOTE', value: 'DOUBLE_QUOTE' },
	BACK_TICK: { label: 'BACK_TICK', value: 'BACK_TICK' },
};

export const TimestampConversionOptions: TimestampConversionOption = {
	IMPLICIT: { label: 'IMPLICIT', value: 'IMPLICIT' },
	TIMESTAMP_prefix: {
		label: 'TIMESTAMP\'YYYY-MM-DD HH:MM:SS\' [Oracle]',
		value: 'TIMESTAMP_prefix',
	},
	TS_function: {
		label: '{TS \'YYYY-MM-DD HH:MM:SS\'} [ClearSCADA]',
		value: 'TS_function',
	},
};
export const TagFieldFormatOptions: TagFieldFormatOption = {
	STRING: { label: 'STRING', value: 'STRING' },
	NUMBER: { label: 'NUMBER', value: 'NUMBER' },
};
